import BaseValidator from './base';

export default class Presence extends BaseValidator {
  message = ' must be present';

  isValid = () => {
    if (this.input) {
      return !!(this.input.value.trim());
    }

    return true;
  };
}
